import validate from '@smarterservices/iam-react-client';
import axios from 'axios';
import { action, observable } from 'mobx';
import { routingStore } from '../../index';
import { api, coreApi, config, setToken } from '../config';

// Helpers
import { getCookie, isLocalStorageSupported } from '../helpers/helpers';

// Dependencies
import browserUpdate from 'browser-update';
import LogRocket from 'logrocket';
import moment from 'moment';

// Components
import SettingsStore from './SettingsStore';

let obx = observable({
  modalContent: null,
  modalLoaded: false,
  modalSmall: false,
  lastFocused: null,
  locale: 'en',
  logRocketInit: false,
  highContrast: false,
  dyslexic: false,
  hideHeader: false,
  hideFooter: false,
  translation: null,
  translationLoaded: false,
  userData: {},
  courseData: {},
  iam: {},
  profile: {},
  impersonateProfile: {},
  failedCalls: [],
  loadingCalls: [],
  loading: false,
  loadingMessage: null,
  loadingClass: '',
  tallyLoad: false,
  tallySteps: [],
  hideDrawerClose: false,
  accountCss: null,
  validateKey: '',
  validater: null,
  backgroundLoadingCalls: [],
  backgroundLoading: false,
  hideMsg: false,
  hasSessionStorage: isLocalStorageSupported(),
  proctorApproved: false,
  proctorConnected: false,
  removeLocalStorage: action(function() {
    sessionStorage.removeItem('registerData');
    sessionStorage.removeItem('userData');
  }),
  browserUnsupported: false,
  checkBrowser: action(function(){
    // Check if browser is supported
    const _this = this;

    browserUpdate({
      notify: {
        e:-1,
        i:11,
        f:-1,
        o:-1,
        s:-1,
        c:-1
      },
      reminder: 0,
      unsupported: true,
      onshow: function() {
        obx.browserUnsupported = true;
      }
    });
  }),
  createLoginUrl: action(function(host) {
      return obx.getParameterByName('account')
  }),
  getInstall: action(function(account) {
    return api.get(`/installs/${account}`)
  }),
  setUserData:action(function(obj) {
    obx.userData = obj;
    // Hide Messages icon for Admins & Instructors
    if (obj && obj.role) {
      const role = String(obj.role).toLowerCase();
      obx.hideMsg = (role === 'administrator' || role === 'instructor');
    }
  }),
  login: action(function(username, password, callback){
    obx.startLoading('Loading…', 'Login');
    const payload = {
      username, password
    }
    api.get(`/installs/${obx.createLoginUrl(window.location.host)}`)
      .then(res => {
        return coreApi.post(`/installs/${res.data.installSid}/login`, payload)
      })
      .then(response => {
        obx.userData = response.data;

        if(response.data.requiresMFASetup) {
          sessionStorage.setItem('mfaUserSid', response.data.userSid);
          sessionStorage.setItem('mfaInstallSid', response.data.installSid);
          const account = obx.getParameterByName('account');
          if (account) {
            sessionStorage.setItem('mfaAccount', account);
          }
          obx.finishLoading('Login');
          routingStore.push('/account/mfa-setup');
          return;
        }

        if(response.data.mfa && response.data.mfa.tempToken) {
          sessionStorage.setItem('mfaTempToken', response.data.mfa.tempToken);
          sessionStorage.setItem('mfaInstallSid', response.data.installSid);
          obx.finishLoading('Login');
          routingStore.push('/account/mfa-challenge');
          return;
        }

        if(response.data.authenticationData) {
          if(obx.hasSessionStorage) {
            sessionStorage.setItem('token', response.data.authenticationData.token);
            sessionStorage.setItem('iam', JSON.stringify(response.data.authenticationData));
          } else {
            document.cookie = `token=${response.data.authenticationData.token}`;
            document.cookie = `iam=${JSON.stringify(response.data.authenticationData)}`;
          }
        }

        if(obx.hasSessionStorage) {
          sessionStorage.setItem('userData', JSON.stringify(obx.userData));
        } else {
          document.cookie = `userData=${JSON.stringify(obx.userData)}`;
        }

        sessionStorage.removeItem('registerData');

        obx.finishLoading('Login');

        if(callback) {
          callback();
        }
      })
      .catch(error => {
        obx.throwError(error)
      });
  }),
  setupMFA: action(function(userSid, installSid, callback) {
    const payload = { type: 'totp' };
    coreApi.post(`/installs/${installSid}/users/${userSid}/mfa/setup`, payload)
      .then(response => {
        if(callback) {
          callback(null, response.data);
        }
      })
      .catch(error => {
        if(callback) {
          callback(error);
        }
      });
  }),
  verifyMFASetup: action(function(userSid, installSid, code, callback) {
    const payload = { type: 'totp', code };
    coreApi.post(`/installs/${installSid}/users/${userSid}/mfa/verify`, payload)
      .then(response => {
        obx.userData = response.data;

        if(response.data.authenticationData) {
          if(obx.hasSessionStorage) {
            sessionStorage.setItem('token', response.data.authenticationData.token);
            sessionStorage.setItem('iam', JSON.stringify(response.data.authenticationData));
          } else {
            document.cookie = `token=${response.data.authenticationData.token}`;
            document.cookie = `iam=${JSON.stringify(response.data.authenticationData)}`;
          }

          setToken(response.data.authenticationData.token);
        }

        if(callback) {
          callback(null, response.data);
        }
      })
      .catch(error => {
        if(callback) {
          callback(error);
        }
      });
  }),
  verifyMFAChallenge: action(function(tempToken, installSid, code, callback) {
    const payload = { tempToken, type: 'totp', code };
    coreApi.post(`/installs/${installSid}/login/verify`, payload)
      .then(response => {
        obx.userData = response.data;

        if(response.data.authenticationData) {
          if(obx.hasSessionStorage) {
            sessionStorage.setItem('token', response.data.authenticationData.token);
            sessionStorage.setItem('iam', JSON.stringify(response.data.authenticationData));
          } else {
            document.cookie = `token=${response.data.authenticationData.token}`;
            document.cookie = `iam=${JSON.stringify(response.data.authenticationData)}`;
          }

          setToken(response.data.authenticationData.token);
        }

        if(obx.hasSessionStorage) {
          sessionStorage.setItem('userData', JSON.stringify(obx.userData));
        } else {
          document.cookie = `userData=${JSON.stringify(obx.userData)}`;
        }

        if(callback) {
          callback(null, response.data);
        }
      })
      .catch(error => {
        if(callback) {
          callback(error);
        }
      });
  }),
  logout: action(function(){
    api.get(`logout`)
      .then(response => {
        window.location.href = '/#/signed-out';
      })
      .catch(error => {
        obx.throwError(error);
      })
  }),
  getParameterByName: function(name, url) {
    if (!url) url = window.location.href;
    name = name.replace(/[\[\]]/g, "\\$&");
    var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
        results = regex.exec(url);
    if (!results) return null;
    if (!results[2]) return '';
    return decodeURIComponent(results[2].replace(/\+/g, " "));
  },
  startLoading: action(function(message, request) {
    obx.loading = true;
    obx.loadingMessage = message;
    obx.loadingCalls.push(request)
  }),
  setValidateKey: action(function(key) {
    obx.validateKey = key
  }),
  createValidate: action(function(key,iam) {
    if(key !== obx.validateKey) {
      obx.setValidateKey(key)
      obx.validater = new validate({iam:iam})
    }
  }),
  alternateModalClose: action(function(){
    obx.modalContent = null;
    obx.modalLoaded = false;
    obx.modalSmall = false;
    obx.modalShort = false;
    obx.modalMediumShort = false;
    obx.modalHeader = null;
    obx.hideTimes = false;




    // Focus last element (if there was) when closing modal
    if (obx.lastFocused) {
      obx.lastFocused.focus();
      obx.lastFocused = null;
    }
  }),

  finishLoading: action(function(request, failed = false) {
    const requestIndex = obx.loadingCalls.indexOf(request);

    if (failed) {
      obx.failedCalls.push(request);
    }

    if(requestIndex >= 0) {
      obx.loadingCalls.splice(requestIndex, 1);
    } else {
      obx.loadingCalls.length = 0;
    }

    if(obx.loadingCalls.length === 0 || typeof request === 'undefined') {
      obx.loadingClass = 'leave';
      obx.loading = false;

      // Wait for loader to fade out before removing
      setTimeout(function(){
        obx.loadingClass = '';
        obx.loadingMessage = null;
      }, 250);
    }
  }),
  startBackgroundLoading: action(function(request) {
    obx.backgroundLoading = true;
    obx.backgroundLoadingCalls.push(request)
  }),
  finishBackgroundLoading: action(function(request) {
    const requestIndex = obx.backgroundLoadingCalls.indexOf(request);

    if(requestIndex >= 0) {
      obx.backgroundLoadingCalls.splice(requestIndex, 1);
    } else {
      obx.backgroundLoadingCalls.length = 0;
    }

    if(obx.backgroundLoadingCalls.length === 0 || typeof request === 'undefined') {
      obx.backgroundLoading = false;
    }
  }),
  // Time zones
  timezoneList: [],
  userTimezone: 'America/Chicago',
  getTimezones: action(function(data) {
    obx.startLoading('Loading…', 'TimeZones');

    api.get(`/timeZones`)
      .then(response => {
        obx.timezoneList = response.data.results;

        if(obx.profile && obx.profile.timeZoneSid) {
          obx.getUserTimezone();
        }

        obx.finishLoading('TimeZones');
      })
      .catch(error => {
        obx.throwError(error)
      });
  }),
  getUserTimezone: action(function() {
    const filteredTZ = obx.timezoneList.filter((tz) => {
      return tz.sid === obx.profile.timeZoneSid;
    });

    obx.userTimezone = filteredTZ[0].name;
    obx.userOffset = moment.tz.zone(obx.userTimezone).utcOffset(moment());
    obx.machineTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone;

    if(obx.machineTimezone) {
      obx.machineOffset = moment.tz.zone(obx.machineTimezone).utcOffset(moment());

      obx.filteredMachineTimezone = obx.timezoneList.filter((tz) => {
        return tz.name === obx.machineTimezone;
      });

      if(obx.machineOffset !== obx.userOffset) {
        obx.notice = true;
        obx.noticeContent.body = `Your time zone is set to ${obx.userTimezone}, but it looks like you are in ${obx.machineTimezone}.`;
        obx.noticeContent.linkText = 'Update Time Zone';
        obx.noticeContent.linkUrl = '#update-timezone';
      } else {
        obx.notice = false;
      }
    }
  }),
  // Current time
  currentTime: null,
  getCurrentTime: action(function(backgroundLoad){
    if(!backgroundLoad) {
      obx.startLoading('Loading…', 'CurrentTime');
    }

    api.get(`/currentTime`)
      .then(response => {
        obx.currentTime = response.data.currentTime;

        if(!backgroundLoad) {
          obx.finishLoading('CurrentTime');
        }
      })
      .catch(error => {
        obx.throwError(error)
      });
  }),
  returnCurrentTime: action(async function(){
    const response = await api.get(`/currentTime`);
    return response.data.currentTime;
    }),
  // Currencies
  currencyList: [],
  getCurrencies: action(function(data) {
    obx.startLoading('Loading…', 'Currencies');

    api.get(`/currencies`)
      .then(response => {
        obx.currencyList = response.data.results;
        obx.finishLoading('Currencies');
      })
      .catch(error => {
        obx.throwError(error)
      });
  }),
  accountList: [],
  getAccounts: action(function(data) {
    obx.startLoading('Loading…', 'Accounts');

    api.get(`/accounts`)
      .then(response => {
        obx.accountList = response.data.results;
        obx.finishLoading('Accounts');
      })
      .catch(error => {
        obx.throwError(error)
      });
  }),
  proctorTypeList: [],
  getProctorTypes: action(function() {
    obx.startLoading('Loading…', 'ProctorTypes');

    api.get(`/proctors/categories?selfSelection=all`)
      .then(response => {
        obx.proctorTypeList = response.data.results;
        obx.finishLoading('ProctorTypes');
      })
      .catch(error => {
        obx.throwError(error)
      });
  }),
  proctorGroupTypes: [],
  getProctorGroupTypes: action(function() {
    // Get proctor types that are assigned to proctor groups
    obx.startLoading('Loading…', 'GetProctorGroupTypes');

    let assignedTypes = [];

    api.get(`installs/${obx.userData.installSid}/proctorGroup`)
      .then(response => {
        response.data.results.forEach(function(group){
          if(group.proctorTypes.length > 0) {
            group.proctorTypes.forEach(function(typeSid){
              assignedTypes.push(typeSid);
            });
          }
        });

        // Remove duplicates and assign the array to the store
        obx.proctorGroupTypes = assignedTypes.filter(function(item, index){
          return assignedTypes.indexOf(item) === index;
        });

        obx.finishLoading('GetProctorGroupTypes');

        obx.getFilteredProctorTypes(true);
      })
      .catch(error => {
        obx.throwError(error)
      })
  }),
  getFilteredProctorTypes: action(function(filterByProctorGroup) {
    obx.startLoading('Loading…', 'FilteredProductTypes');

    // Get allowed proctor types from install settings
    let allowedTypes = [];

    api.get(`installs/${obx.userData.installSid}/settings`)
      .then(response => {
        response.data.proctorTypes.forEach(function(type){
          if(type.proctorTypeSubCategorySid) {
            const typeObject = {
              sid: type.proctorTypeSubCategorySid,
              status: type.status
            }

            allowedTypes.push(typeObject);
          }
        });

        obx.filterProctors(allowedTypes, filterByProctorGroup);
        obx.finishLoading('FilteredProductTypes');
      })
  }),
  // Get all proctor types and filter to only get allowed ones
  filterProctors: action(function(allowedTypes, filterByProctorGroup) {
    obx.startLoading('Loading…', 'AllProctorTypes');

    api.get(`/proctors/categories?selfSelection=all`)
      .then(response => {
        doFilter(response.data.results, allowedTypes);
        obx.finishLoading('AllProctorTypes');
      })
      .catch(error => {
        obx.throwError(error)
      })

    function doFilter(allTypes, allowedTypes) {
      let filteredTypes = [];

      allTypes.map(
        (key, i) =>
        {
          key.subCategories.filter(function(obj){
            for(let k = 0; k < allowedTypes.length; k++) {
              if(allowedTypes[k].sid === obj.sid) {
                return true;
              }
            }

            return false;
          }).map(
            (subKey, j) =>
            {
              if(filteredTypes.indexOf(key) < 0) {
                key.subCategories = [];
                filteredTypes.push(key);
              }

              for(let k = 0; k < allowedTypes.length; k++) {
                if(allowedTypes[k].sid === subKey.sid) {
                  subKey.status = allowedTypes[k].status;
                }
              }

              const keyIndex = filteredTypes.indexOf(key);
              filteredTypes[keyIndex].subCategories.push(subKey)

              return true;
            }
          )

          return true;
        }
      );

      // If specified, filter the results further to only show those that are
      // assigned to a proctor group
      if(filterByProctorGroup) {
        filteredTypes.forEach(function(parentType){
          if(parentType.subCategories.length > 0) {
            parentType.subCategories.forEach(function(subType){
              const subTypeIndex = parentType.subCategories.indexOf(subType);

              if(obx.proctorGroupTypes.indexOf(subType.sid) <= -1) {
                parentType.subCategories.splice(subTypeIndex, 1);
              }
            })
          }
        });
      }

      obx.proctorTypeList = filteredTypes;
    }
  }),

  sessionConfigurations: [],
  getSessionConfigurations: action(function() {
    obx.startLoading('Loading…', 'SessionConfigurations');

    api.get(`installs/${obx.userData.installSid}/sessionConfigurations`)
      .then(response => {
        obx.sessionConfigurations = response.data.results;
        obx.finishLoading('SessionConfigurations');
      })
      .catch(error => {
        obx.throwError(error)
      });
  }),

  updateLocale: action(function(locale) {
    obx.locale = locale;
    obx.getTranslation(locale);
  }),
  dialog: false,
  dialogContent: {
    heading: null,
    body: null,
    button: null
  },
  dialogCallback: null,
  confirm: false,
  confirmContent: {
    heading: null,
    body: null,
    data: null,
    cancel: null,
    button: null
  },
  confirmCallback: null,
  prompt: false,
  promptContent: {
    heading: null,
    body: null,
    options: null,
    button: null
  },
  promptSelectFunc: null,
  promptCallback: null,
  throwError: action(function(error) {
    obx.finishLoading();
    obx.finishBackgroundLoading();

    console.error(error);

    if(typeof error.response !== 'undefined') {
      // API errors will return an error object with a response
      // which means we have a message for them
      obx.showError(error.response.data);
    } else {
      // If there’s no response with the error, it’s a server
      // connection error (i.e. axios can’t reach the URL)
      obx.showError();
    }

    obx.tallyLoad = false;
    obx.tallySteps = [];
  }),
  notice: false,
  noticeContent: {
    body: null,
    linkText: null,
    linkUrl: null
  },
  expireWarning: false,
  expireSession: action(function() {
    window.location.href = '/#/session-expired';
  }),
  showExpireWarning: action(function() {
    obx.expireWarning = true;
  }),
  removeExpireWarning: action(function() {
    obx.expireWarning = false;
  }),
  extendSession: action(function(callback) {
    let headers = {};

    if(obx.hasSessionStorage) {
      headers = {
        'token': sessionStorage.getItem('token')
      }
    } else {
      headers = {
        'token': getCookie('token')
      }
    }

    api.get('/check', { headers })
      .then(response => {
        if(callback) {
          callback();
        }
      })
      .catch(error => {
        obx.throwError(error);
      })
  }),
  showDialog: action(function(content) {
    if(content) {
      obx.dialogContent = content;
    }

    obx.dialog = true;

    // Focus the confirmation dialog for screen readers
    setTimeout(function(){
      const dialogMsg = document.querySelector('.dialog__msg');

      if(dialogMsg) {
        dialogMsg.focus();
      }
    })
  }),
  showError: action(function(data) {
    obx.dialog = true;
    obx.dialogContent.heading = obx.translation.Errors.heading;
    obx.dialogContent.button = obx.translation.Errors.button;

    // Server error (no data present because API didn’t return anything)
    if(!data) {
      obx.dialogContent.body = obx.translation.Errors[1301].message;
    } else {
      // API returned data
      if(typeof obx.translation.Errors[data.code] !== 'undefined') {
        if(data.code !== '1380') {
          obx.dialogContent.body = obx.translation.Errors[data.code].message;
        } else {
          const startDate = data.message.match(/'(.*?)'/g)[0];
          const endDate = data.message.match(/'(.*?)'/g)[1];

          obx.dialogContent.body =
            obx.translation.Errors[data.code].message
               .replace(
                 '%startDate%',
                 moment(startDate).tz(obx.userTimezone).format('M/D/YYYY [at] h:mma z')
               )
               .replace(
                 '%endDate%',
                 moment(endDate).tz(obx.userTimezone).format('M/D/YYYY [at] h:mma z')
               );
        }
      } else {
        console.warn('Error code not present in translation file. Falling back to API response message');
        obx.dialogContent.body = data.message;
      }
    }

    if(data && data.code === '5002') {
      window.location.href = '/#/session-expired';
    }
  }),
  showConfirm: action(function(msg, func) {
    obx.confirm = true;
    obx.confirmContent.heading = msg.heading;
    obx.confirmContent.body = msg.body;

    if(msg.data) {
      obx.confirmContent.data = msg.data;
    }

    if(msg.cancel) {
      obx.confirmContent.cancel = msg.cancel;
    }

    obx.confirmContent.button = msg.button;
    obx.confirmCallback = func;

    // Focus the confirmation dialog for screen readers
    setTimeout(function(){
      const dialogMsg = document.querySelector('.dialog__msg');

      if(dialogMsg) {
        dialogMsg.focus();
      }
    });
  }),
  showPrompt: action(function(msg, selectFunc, callback, text) {
    obx.prompt = true;
    obx.promptContent.heading = msg.heading;
    obx.promptContent.body = msg.body;
    obx.promptContent.options = msg.options;
    obx.promptContent.button = msg.button;
    obx.promptSelectFunc = selectFunc;
    obx.promptCallback = callback;

    if(msg.input) {
      obx.promptContent.input = msg.input;
    }

    if(text) {
      obx.promptText = text;
    }

    // Focus the prompt dialog for screen readers
    setTimeout(function(){
      const dialogMsg = document.querySelector('.dialog__msg');

      if(dialogMsg) {
        dialogMsg.focus();
      }
    });
  }),
  closeDialog: action(function() {
    obx.expireWarning = false;
    obx.dialog = false;
    obx.confirm = false;
    obx.confirmContent.data = null;
    obx.confirmContent.cancel = null;
    obx.prompt = false;
    obx.promptContent.options = null;

    // Focus the confirmation main content element
    setTimeout(function(){
      const main = document.querySelector('#main-content');

      if(main) {
        main.focus();
      }
    });

    // If a dialog callback has been defined
    if(obx.dialogCallback) {
      obx.dialogCallback();
      obx.dialogCallback = null;
    }
  }),
  confirmFunc: action(function() {
    obx.confirm = false;
    if(obx.confirmCallback) {
      obx.confirmCallback();
    }
  }),
  promptFunc: action(function() {
    obx.prompt = false;
    if(obx.promptCallback) {
      obx.promptCallback();
    }
  }),
  getTranslation: action(function(locale){
    obx.translationLoaded = true;

    const timestamp = (new Date()).getTime();

    axios.get(`./json/${locale}.json?t=${timestamp}`)
      .then(response => {
        obx.translation = response.data.content;
      });
  }),
  checkToken: action(function(){
    obx.startLoading('Loading…', 'CheckToken');

    let headers = {};

    if(obx.hasSessionStorage) {
      headers = {
        'token': sessionStorage.getItem('token')
      }
    } else {
      headers = {
        'token': getCookie('token')
      }
    }

    Promise.all([api.get(`/check`, {headers}),api.get(`/permissions`, {headers})])
      .then(arr => {
        if(obx.hasSessionStorage) {
          sessionStorage.setItem('userData', JSON.stringify(arr[0].data));
          sessionStorage.setItem('iam', JSON.stringify(arr[1].data));
        } else {
          document.cookie = `userData=${JSON.stringify(arr[0].data)}`;
          document.cookie = `iam=${JSON.stringify(arr[1].data)}`;
        }

        obx.userData = arr[0].data;
        // Hide Messages icon for Admins & Instructors
        if (obx.userData && obx.userData.role) {
          const role = String(obx.userData.role).toLowerCase();
          obx.hideMsg = (role === 'administrator' || role === 'instructor');
        }
        obx.iam = arr[1].data;

        if(obx.userData && obx.userData.role && obx.userData.role.toLowerCase() !== 'administrator') {
          obx.getCourseData();
        }

        obx.getSettings();
        obx.finishLoading('CheckToken');
      })
      .catch(error => {
        obx.throwError(error);
      });
  }),
  getCourseData: action(function(sid, backgroundLoad){
    if(!backgroundLoad) {
      obx.startLoading('Loading…', 'GetCourseData');
    } else {
      obx.startBackgroundLoading('GetCourseData');
    }

    let courseSid = null;

    if(sid) {
      courseSid = sid;
    } else {
      courseSid = obx.userData.courseSid;
    }

    api.get(`/installs/${obx.userData.installSid}/courses/${courseSid}`)
      .then(response => {
        obx.courseData = response.data;

        if(obx.hasSessionStorage) {
          sessionStorage.setItem('courseData', JSON.stringify(response.data));
        } else {
          document.cookie = `courseData=${JSON.stringify(response.data)}`;
        }

        if(!backgroundLoad) {
          obx.finishLoading('GetCourseData');
        } else {
          obx.finishBackgroundLoading('GetCourseData');
        }
      })
      .catch(error => {
        obx.throwError(error);
      });
  }),
  getProfile: action(function(sid, impersonate, component, callback){
    obx.startLoading('Loading…', 'GetProfile');

    let userSid = obx.userData.userSid;

    if(sid) {
      userSid = sid;
    }

    api.get(`/installs/${obx.userData.installSid}/users/${userSid}/profile`)
      .then(response => {
        obx.finishLoading('GetProfile');
        if(!impersonate) {
          obx.profile = response.data;

          SettingsStore.userSettings = response.data;

          // Set LogRocket identity data
          if(obx.userData.enrollmentSid) {
            // Enrollment data (student or instructor)
            LogRocket.identify(obx.userData.enrollmentSid, {
              name: `${obx.profile.lastName}, ${obx.profile.firstName}`,
              email: obx.profile.email,
              role: obx.userData.role,
              userSid: obx.userData.userSid,
              enrollmentSid: obx.userData.enrollmentSid,
              courseSid: obx.userData.courseSid,
              installSid: obx.userData.installSid,
              integrationSid: obx.userData.integrationSid,
              deploymentSid: obx.userData.deploymentSid,
              appInstallName: obx.userData.smarterProctoring.appInstallName,
              applicationSid: obx.userData.applicationSid || obx.userData.smarterProctoring.applicationSid
            });
          } else {
            // User data (admin)
            LogRocket.identify(obx.userData.userSid, {
              name: `${obx.profile.lastName}, ${obx.profile.firstName}`,
              email: obx.profile.email,
              role: obx.userData.role,
              userSid: obx.userData.userSid,
              installSid: obx.userData.installSid,
              integrationSid: obx.userData.integrationSid,
              deploymentSid: obx.userData.deploymentSid
              // appInstallName: obx.userData.smarterProctoring.appInstallName,
              // applicationSid: obx.userData.smarterProctoring.applicationSid
            });
          }

          // Set Cobrowse identity data
          if(window.CobrowseIO && process.env.REACT_APP_ENVIRONMENT) {
            window.CobrowseIO.customData = {
              name: `${obx.profile.lastName}, ${obx.profile.firstName}`,
              user_email: obx.profile.email,
              role: obx.userData.role,
              userSid: obx.userData.userSid,
              installSid: obx.userData.installSid,
              integrationSid: obx.userData.integrationSid,
              deploymentSid: obx.userData.deploymentSid,
              enrollmentSid: obx.userData.enrollmentSid ? obx.userData.enrollmentSid : 'N/A'
            };
          }

          // Set up Google Analytics
          let gaTrackingId = null;

          if(obx.userData.enrollmentSid) {
            // Course tracking
            gaTrackingId = config.gaCourse;
          } else {
            // Admin tracking
            gaTrackingId = config.gaAdmin;
          }

          const gaScript = document.createElement('script');
          gaScript.id = 'ga-script';
          gaScript.type = 'text/javascript';
          gaScript.async = true;
          gaScript.src = `https://www.googletagmanager.com/gtag/js?id=${gaTrackingId}`;

          // Append Google Analytics script
          document.body.appendChild(gaScript);

          // Config Google Analtyics
          window.dataLayer = window.dataLayer || [];
          function gtag(){window.dataLayer.push(arguments);}
          gtag('js', new Date());

          // Add installSid dimension
          gtag('config', gaTrackingId, {
            'custom_map': {'dimension1': 'installSid'}
          });

          gtag('event', 'installSid', {'installSid': obx.userData.installSid});

          // Add role dimension
          gtag('config', gaTrackingId, {
            'custom_map': {'dimension2': 'role'}
          });

          gtag('event', 'role', {'role': obx.userData.role});

          // Initialize Google Analytics
          gtag('config', gaTrackingId);

          // Create tracker
          const gaDelay = setInterval(function(){
            if(window.ga) {
              clearInterval(gaDelay);
              window.ga('create', gaTrackingId, 'auto');
            }
          }, 100);

          // Set up Countly
          if(
            obx.userData.role &&
            obx.userData.role.toLowerCase() === 'administrator'
          ) {
            const ctScript = document.createElement('script');
            ctScript.id = 'countly-script';
            ctScript.type = 'text/javascript';
            ctScript.async = true;
            ctScript.src = 'https://cdn.jsdelivr.net/npm/countly-sdk-web@latest/lib/countly.min.js';

            ctScript.onload = () => {
              const Countly = window.Countly;

              Countly.init({
                app_key: 'eb3a5afccf801c45e82fd2366688f490df0b9df5',
                url: '//try.count.ly'
              });

              Countly.track_sessions();
              Countly.track_pageview();

              Countly.q.push(['user_details', {
                  'name': `${obx.profile.firstName} ${obx.profile.lastName}`,
                  'email': obx.profile.email,
                  'organization': obx.userData.smarterProctoring ? obx.userData.smarterProctoring.appInstallName : obx.userData.installSid,
                  'phone': obx.profile.mobilePhone || '',
                  'custom':{
                    'installSid': obx.userData.installSid,
                    'userSid': obx.userData.userSid,
                    'role': obx.userData.role,
                    'deploymentSid': obx.userData.deploymentSid,
                    'enrollmentSid': obx.userData.enrollmentSid || '',
                    'integrationSid': obx.userData.integrationSid,
                    'courseSid': obx.userData.courseSid || '',
                    'timeZone': obx.userData.userTimezone
                  }
              }]);

              Countly.q.push(['track_pageview', location.pathname + location.hash]);

              window.addEventListener('hashchange', () => {
                Countly.q.push(['track_pageview', location.pathname + location.hash]);
              });
            }

            document.body.appendChild(ctScript);
          }
        } else {
          obx.impersonateProfile = response.data;

          if(component) {
            const location = {
              latitude: response.data.latitude,
              longitude: response.data.longitude
            }

            component.setState({
              location
            });

            if(callback) {
              callback();
            }
          }
        }

        // if(response.data.smarterId === null && obx.userData.role.toLowerCase() === 'learner' && obx.settings.smarterIdEnabled) {
        //   // If SmarterID value is null, create new user in SmarterID
        //   SmarterIDStore.createSIDUser();
        // } else if(obx.userData.role.toLowerCase() === 'learner' && obx.settings.smarterIdEnabled) {
        //   // Check if the user has an enrollment in SmarterID
        //   SmarterIDStore.checkSIDEnrollment();
        // }

        if(obx.userData.role.toLowerCase() === 'instructor') {
          // If this is an instructor, get and store the integration data
          // so it can be used to impersonate students
          SettingsStore.getIntegration(obx.userData.integrationSid);
        } else if (obx.userData.role.toLowerCase() === 'administrator') {
          // Otherwise, if this is an administrator, check how many
          // integrations there are. If there is only one, store
          // the data so it can be used to impersonate students
          const callback = (response) => {
            if(response.data.results.length === 1) {
              SettingsStore.integration = response.data.results[0];
            }
          }

          SettingsStore.getIntegrations(callback);
        }

        // If user is an administrator or instructor, get the institution settings
        if(
          obx.userData.role.toLowerCase() === 'administrator' ||
          obx.userData.role.toLowerCase() === 'instructor'
        ) {
          SettingsStore.getInstituteSettings();
        }

        // Get list of time zones
        obx.getTimezones();
      })
      .catch(error => {
        obx.throwError(error);
      });
  }),
  // Get install settings to check if SmarterID is enabled
  settings: {},
  getSettings: action(function(){
    obx.startLoading('Loading…', 'GetInstallSettings');

    api.get(`/installs/${obx.userData.installSid}/settings`)
      .then(response => {
        obx.settings = response.data;
        obx.finishLoading('GetInstallSettings');
        obx.getProfile();
      })
      .catch(error => {
        obx.throwError(error);
      })
  }),
  checkProfile: action(function(){
    // If this is a student and they do not have all of their
    // required profile information completed, redirect them
      let sessionInstallSid = sessionStorage.getItem('installSid');
      let isDMV = config.dmvInstallSids.includes(sessionInstallSid)

    if(
        typeof obx.userData.role !== 'undefined' &&
        obx.userData.role.toLowerCase() === 'learner' &&
        (!obx.profile.latitude || !obx.profile.longitude || !obx.profile.timeZoneSid || !obx.profile.currencyCode) &&
        routingStore.location.pathname !== '/enroll' &&
        routingStore.location.pathname !== '/session-start' &&
        routingStore.location.pathname !== '/session-start/' &&
        isDMV !== true
      ) {
      routingStore.push({
        pathname: '/enroll',
      });
    }

    // If there is an entry point in the user data,
    // check if the entry point has already been stored.
    // If it has not, redirect to the entry point.
    if(obx.userData.ui && (obx.userData.ui.entry_point || obx.userData.ui.entryPoint)) {
      let storedEntryPoint = null
      let entryPoint = null;

      if(obx.userData.ui.entry_point) {
        entryPoint = obx.userData.ui.entry_point;
      } else {
        entryPoint = obx.userData.ui.entryPoint;
      }

      if(obx.hasSessionStorage) {
        storedEntryPoint = sessionStorage.getItem('entryPoint');
      } else {
        storedEntryPoint = getCookie('entryPoint');
      }

      if(!storedEntryPoint && routingStore.location.pathname !== '/enroll') {
        // Redirect if enrollment is not required
        obx.redirectToEntryPoint(entryPoint);
      } else if (!storedEntryPoint && routingStore.location.pathname === '/enroll') {
        // Otherwise, if enrollment is required, redirect afterward
        obx.afterEnroll = entryPoint;
      }
    }
  }),
  afterEnroll: '/',
  redirectToEntryPoint: action(function(entryPoint){
    if(obx.hasSessionStorage) {
      sessionStorage.setItem('entryPoint', entryPoint);
    } else {
      document.cookie = `entryPoint=${entryPoint}`;
    }

    switch (entryPoint) {
      case 'choose_exam':
        if(obx.userData.ui.sid) {
          routingStore.push({
            pathname: `schedule-session/group/${obx.userData.ui.sid}`,
          });
        }

        break;

      default:
        if(obx.userData.ui.sid) {
          routingStore.push({
            pathname: `schedule-session/group/${obx.userData.ui.sid}`,
          });
        }

        break;
    }
  }),
  unreadCount: 0,
  getUnreadCount: action(function(backgroundLoad, notify, content, link){
    if(!backgroundLoad) {
      obx.startLoading('Loading…', 'GetUnreadCount');
    }

    if(obx.userData.courseSid) {
      api.get(`/messages/counts?userSid=${obx.userData.userSid}&courseSid=${obx.userData.courseSid}`)
        .then(response => {
          const newCount = parseInt(response.data.unread, 10);

          if(notify === true && newCount > obx.unreadCount) {
            obx.showNotification(content, link);
          }

          obx.unreadCount = newCount;

          if(!backgroundLoad) {
            obx.finishLoading('GetUnreadCount');
          }
        })
        .catch(error => {
          obx.throwError(error)
        });
    } else {
      api.get(`/messages/counts?userSid=${obx.userData.userSid}`)
        .then(response => {
          const newCount = parseInt(response.data.unread, 10);

          if(notify === true && newCount > obx.unreadCount) {
            obx.showNotification(content, link);
          }

          obx.unreadCount = newCount;

          if(!backgroundLoad) {
            obx.finishLoading('GetUnreadCount');
          }
        })
        .catch(error => {
          obx.throwError(error)
        });
    }
  }),
  notification: false,
  notificationContent: null,
  notificationLink: null,
  notificationClass: null,
  notificationDuration: 10000,
  showNotification: action(function(content, link) {
    if(content) {
      obx.notificationContent = content;
    }

    if(link) {
      obx.notificationLink = link;
    }

    obx.notification = true;
  }),
  closeNotification: action(function() {
    obx.notification = false;
    obx.notificationContent = null;
    obx.notificationLink = null;
    obx.notificationDuration = 10000;
  }),
  showToaster: action(function(content, type, duration = 10000, modifier) {
    if(content) {
      obx.notificationContent = content;
    }

    if(type === 'success') {
      obx.notificationClass = 'notify--success';
    }
    if(type === 'warning') {
      obx.notificationClass = 'notify--warning';
    }
    if(type === 'error') {
      obx.notificationClass = 'notify--error';
    }

    if(modifier) {
      obx.notificationClass += ` ${modifier}`;
    }

    obx.notificationDuration = duration;
    obx.notification = true;
  }),

  /**
   * getExtensionInfo
   */
  extensionInfo: null,

  getExtensionInfo: action(function(){
    const timestamp = (new Date()).getTime();
    axios.get(`${config.extensionManifestUrl}?t=${timestamp}`).then(response => {
        obx.extensionInfo = response.data;

        if(localStorage.getItem('extensionId')) {
          obx.extensionInfo.extensionId = localStorage.getItem('extensionId');
        } else if(config.extensionId) {
          obx.extensionInfo.extensionId = config.extensionId;
        }
      });
  }),

  /**
   * Boolean to check if we connected to the desktop app
   */
  desktopAppConnected: false,

  /**
   * Boolean to check if we connected to the desktop app
   */
  desktopAppRequestLoading: false,

  /**
   * Post to the desktop app the exam session info
   */
  connectWithDesktopApp: action(function(token, sessionSid, installSid, examSid) {
    // Set we are loading so we do not request multiple
    obx.desktopAppRequestLoading = true;
    axios.post(`${config.desktopAppBaseUrl}/accept/${token}/${sessionSid}/${installSid}/${examSid}`).then(response => {
      console.log('response', response);
      obx.desktopAppConnected = true;
    }).catch((e) => {
      console.log('desktop app error', e);
      obx.desktopAppRequestLoading = false;
    });
  }),

  /**
   * Post to the desktop app to close all the running apps
   */
  desktopAppCloseBlockedApps: action(function(done) {
    // Using the callback to set the loading in the component state
    // when i was trying to use a property of the store and updating that did not seem to work
    axios.post(`${config.desktopAppBaseUrl}/close-blocked-applications`).then(response => {
      done();
    }).catch((e) => {
      console.log('desktopAppCloseBlockedApps error');
      console.error(e.message);
      done();
    });
  }),

  /**
   * Calculator type (controls ClassCalc rendering)
   */
  calculator: null
});

export default obx;



// WEBPACK FOOTER //
// ./src/app/stores/SessionStore.js